import ModuleProvider from './moduleProvider';

class ModuleProviderFactory {
	common = new ModuleProvider();
	application = new ModuleProvider();
	platform = new ModuleProvider();

	get(name) {
		if (this[name] === undefined) {
			this[name] = new ModuleProvider();
		}

		return this[name];
	}
}

export default new ModuleProviderFactory();
